import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";

import { useFilteredProducts } from "./hooks/useFilteredProducts";
import { useFilteredVendors } from "./hooks/useFilteredVendors";
import { SearchTermInput } from "./SearchTermInput";
import { PreviewList } from "./PreviewList";
import { ProductsTable } from "./ProductsTable";
import useGetAllProducts from "../../../hooks/useGetAllProducts";

export const ProductSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showPreviewList, setShowPreviewList] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const { products, loading: loadingProducts } = useGetAllProducts();

  const filteredProducts = useFilteredProducts(
    products,
    searchTerm.toLocaleLowerCase()
  );
  const filteredVendors = useFilteredVendors(searchTerm.toLocaleLowerCase());

  useEffect(() => {
    setShowPreviewList(searchTerm.length >= 2);
    setShowTable(false);
  }, [searchTerm]);

  const handleOnSearchTermInputFocus = () => {
    setShowPreviewList(searchTerm.length > 0);
    setShowTable(false);
  };

  const handleOnViewAllProducts = () => {
    setShowPreviewList(false);
    setShowTable(true);
  };

  return (
    <Stack pt={1}>
      <SearchTermInput
        loadingProducts={loadingProducts}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onFocus={handleOnSearchTermInputFocus}
        onSearch={handleOnViewAllProducts}
      />

      <PreviewList
        open={showPreviewList}
        loadingProducts={loadingProducts}
        productsList={filteredProducts}
        vendorsList={filteredVendors}
        onViewAllProducts={handleOnViewAllProducts}
        onClose={() => {
          setShowPreviewList(false);
        }}
      />

      {showTable && (
        <ProductsTable
          baseId="product-search-table"
          search={searchTerm}
          filteredProducts={filteredProducts}
        />
      )}
    </Stack>
  );
};
